import printomioLogo from '../img/logo.png';
import { useTranslation } from 'react-i18next';

function Printomio() {
    const { t } = useTranslation()
    return (
        <>
            <div className="px-4">
                <img className="logo" style={{ maxWidth: "300px", margin: "0 auto", display: "block" }} src={printomioLogo} alt="Printomio - Social Printing" />
            </div>
            <div className="Layer px-4">
                <h1>Printomio powered by L&amp;S Digital GmbH &amp; Co. KG</h1>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                <a href="/" className="d-block btn btn-primary mb-2 rounded-pill">{t("general.back_link")}</a>
            </div>
        </>
    )
}

export default Printomio
